__webpack_require__.p = "https://quickapply-sit.rakbanktst.ae/digitalbank/";